import axios from 'axios';

export default {
  name: 'prodify',
  component() {
      return {
        el: '',
        pickerType: '',
        selectors: '',
        textStrings: '',
        currentVariant: '',
        optionContainers: '',
        options: '',
        variantData: '',
        popup: false,
        calcGuide: false,
        body: "",
        scrollTopLock: 0,
        currentVariantStock: 0,
        openColors: false,
        colorsLoaded: false,
        isLoadingColors: false,
        openWallpaperCalc: false,
        chosenColor: null,
        searchColor: "",
        colorCategory: "",
        chosenColor: {
          id: '',
          name: '', 
          colorBook: '', 
          description: '', 
          color: ''
        },
        isAddingColorChoice: false,
        cartRequestHandler: null,
        colors: [],
        // isLoadingColors: false,
        // quantityIncrementButton: '',
        // quantityDecrementButton: '',
        // quantityPresentationInput: '',
        // quantityHiddenInput: '',

        init() {
            this.body = document.querySelector("body");

            this.$watch("calcGuide", (val) => {
                if (val) {
                    this.enableBodyScrollLock();
                } else {
                    this.disableBodyScrollLock();
                }
            });

            this.$watch("openColors", (val) => {
              if (val) {
                  this.enableBodyScrollLock();
              } else {
                  this.disableBodyScrollLock();
              }
          });

          this.el = this.$root;
          this.pickerType = this.el.dataset.prodify;

          this.selectors = {
            priceContainer: '[data-prodify-price-container]',
            mediaContainer: '[data-prodify-media-container]',
            variantsJson: '[data-prodify-variants-json]',
            optionContainer: '[data-prodify-option-container]',
            productForm: '[data-prodify-product-form]',
            // quantityIncrement: '[data-prodify-quantity-increment]',
            // quantityDecrement: '[data-prodify-quantity-decrement]',
            // quantityPresentation: '[data-prodify-quantity-presentation]',
          }
      
          this.textStrings = {
            addToCart: window.variantStrings.addToCart,
            unavailableVariantValueLabel: window.variantStrings.unavailable_with_option,
            soldOutVariantValueLabel: window.variantStrings.soldout_with_option,
            addButtonTextUnavailable: window.variantStrings.unavailable,
          }
      
          // this.quantityIncrementButton = this.el.querySelector(this.selectors.quantityIncrement)
          // this.quantityDecrementButton = this.el.querySelector(this.selectors.quantityDecrement)
          // this.quantityPresentationInput = this.el.querySelector(this.selectors.quantityPresentation)
          // this.quantityHiddenInput = this.el.querySelector('input[name="quantity"]')
      
          this.initEventListeners()
        },

        openColorPicker() {
          this.openColors = true;
          if (!this.colorsLoaded) {
            // Wait for the drawer's open transition (duration-300) to finish
            // before fetching, so the loader/list doesn't pop in mid-animation.
            setTimeout(() => this.loadColors(), 300);
          }
        },
      
        initEventListeners() {
          this.onVariantChange()

          // Prevent form from submitting (we handle it via addToCart method)
          const productForm = this.el.querySelector(this.selectors.productForm);
          if (productForm) {
            // Use capture phase to catch it before liquid-ajax-cart
            productForm.addEventListener('submit', (e) => {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              // console.log('Form submit prevented');
              return false;
            }, { capture: true, passive: false });
            
            // Also prevent on the form itself
            productForm.onsubmit = function(e) {
              e.preventDefault();
              e.stopPropagation();
              // console.log('Form onsubmit prevented');
              return false;
            };
          }

          // Only add listener if it doesn't already exist
          if (this.cartRequestHandler) {
            return;
          }

          // Store the handler so we can remove it later
          this.cartRequestHandler = (event) => {
            const { requestState, cart, previousCart, sections } = event.detail;
            
            // Prevent infinite loop: don't process if we're already adding a color choice
            if (this.isAddingColorChoice) {
              return;
            }
            
            // Only process requests that came from our component
            // This prevents processing form submissions from liquid-ajax-cart or other sources
            const requestInfo = requestState?.info || {};
            
            // Debug logging
            // console.log('Cart request:', {
            //   requestType: requestState.requestType,
            //   fromProdify: requestInfo.fromProdifyComponent,
            //   productId: requestInfo.productId,
            //   ourProductId: this.el.dataset.id,
            //   requestBody: requestState.requestBody
            // });
            
            if (!requestInfo.fromProdifyComponent || requestInfo.productId !== this.el.dataset.id) {
              // console.log('Skipping request - not from our component');
              return;
            }
            
            if (requestState.requestType === 'add') {
              // Check the request body to see what was actually sent
              const requestBody = requestState.requestBody;
              if (requestBody && requestBody.items) {
                // Check if any item in the request doesn't have properties
                const itemWithoutProperties = requestBody.items.find(item => !item.properties || Object.keys(item.properties).length === 0);
                if (itemWithoutProperties) {
                  // console.warn('Request contains item without properties - this might be a duplicate form submission');
                  // Don't process this request further
                  return;
                }
              }
              
              // Properties are on the cart items, not directly on the response body
              const addedItem = cart?.items?.[cart.items.length - 1];
              if (!addedItem) return;
              
              // Only process if this is OUR product (from this component instance)
              const ourProductId = this.el.dataset.id;
              const addedProductId = addedItem.product_id?.toString();
              
              // Skip if this is not our product
              if (addedProductId !== ourProductId) {
                return;
              }
              
              // Skip if it's the color choice product itself
              if (addedProductId === this.chosenColor?.id?.toString()) {
                return;
              }
              
              const colorProperty = addedItem?.properties?.color;
              
              // Only add color choice if:
              // 1. The item has a color property
              // 2. We have a chosen color ID set
              if (colorProperty && 
                  colorProperty !== '' && 
                  this.chosenColor?.id) {
                this.addColorChoice();
              }
            } 
          };

          document.addEventListener("liquid-ajax-cart:request-end", this.cartRequestHandler);

          window.addEventListener('remove_color_choice', () => {
            this.removeColorChoice();
          });
        },

        enableBodyScrollLock() {
            this.scrollTopLock =
                document.documentElement.scrollTop || document.body.scrollTop;
            this.body.style.overflow = "hidden";
            this.body.style.position = "fixed";
            this.body.style.top = `-${this.scrollTopLock}px`;
            this.body.style.width = "100%";
        },
    
        disableBodyScrollLock() {
            this.body.style.removeProperty("overflow");
            this.body.style.removeProperty("position");
            this.body.style.removeProperty("top");
            this.body.style.removeProperty("width");
            window.scrollTo(0, this.scrollTopLock);
        },

        onVariantChange() {
          this.updateCurrentOptions()
          this.updateCurrentVariant()
          this.compareInputValues()

          // this.updateAddButtonDom(true, '', false)
          // this.setOptionSelected(this.$el)
          
          if (!this.currentVariant) {
            // this.updateAddButtonDom(true, this.textStrings.addButtonTextUnavailable, true)
          } else {
            // this.updateURL()
            this.updateVariantIdInput()
            // this.swapProductInfo()
          }
        },
      
        updateCurrentVariant() {
          const variants = this.getVariantData();
          const matchingVariant = variants.find(variant => {
            return variant.options.every((option, index) => {
              return this.options[index] === option;
            });
          });
          this.currentVariant = matchingVariant;
          console.log(this.currentVariant);
        },
      
        // updateQuantity(stepDirection) {
        //   const previousQuantity = parseInt(this.quantityPresentationInput.value)
      
        //   if (stepDirection == 'up') {
        //     this.quantityHiddenInput.value = this.quantityPresentationInput.value = previousQuantity + 1
        //   } else {
        //     this.quantityHiddenInput.value = this.quantityPresentationInput.value = Math.max(1, previousQuantity - 1)
        //   }
        // },
      
        updateCurrentOptions() {
          if (this.pickerType == 'select') {
            this.options = Array.from(this.el.querySelectorAll('select'), (select) => select.value)
            return
          }
      
          this.optionContainers = Array.from(this.el.querySelectorAll(this.selectors.optionContainer))
          // console.log(this.optionContainers);

          this.options = this.optionContainers.map((optionContainer) => {
            const option = Array.from(optionContainer.querySelectorAll('input')).find((radio) => radio.checked);
            return option.value;
            // if (option === undefined) {
            //   const option2 = optionContainer.querySelector('input[checked]');
            //   console.log(option2);
            //   option2.checked = true;
            //   return option2.value;
            // } else {
            //   return option.value;
            // }
          })   
        },
      
        updateVariantIdInput() {
          const productForms = this.$root.querySelectorAll(this.selectors.productForm)
          // console.log(productForms);
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]')
            input.value = this.currentVariant.id
            // input.dispatchEvent(new Event('change', { bubbles: true }));
          })
        },
      
        updateURL() {
          if (!this.currentVariant || this.el.dataset.updateUrl === 'false') return
          window.history.replaceState({}, '', `${this.el.dataset.url}?variant=${this.currentVariant.id}`)
        },
      
        compareInputValues() {
          const variantsMatchingOptionOneSelected = this.variantData.filter(
            // Grab the first checked input and compare it to the variant option1
            // return an array of variants where the option1 matches the checked input
            (variant) => this.el.querySelector(':checked').value === variant.option1
          )
      
          const inputWrappers = [...this.el.querySelectorAll(this.selectors.optionContainer)]
          inputWrappers.forEach((option, index) => {
            if (index === 0) return
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value
            const availableOptionInputsValues = variantsMatchingOptionOneSelected
              .filter(
                // 
                (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])
      
            const existingOptionInputsValues = variantsMatchingOptionOneSelected
              .filter(
                // 
                (variant) => variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])
      
            this.setInputAvailability(optionInputs, availableOptionInputsValues, existingOptionInputsValues)
          })
        },
      
        setInputAvailability(optionInputs, availableOptionInputValues, existingOptionInputsValues) {
          optionInputs.forEach((input) => {
            if (availableOptionInputValues.includes(input.getAttribute('value'))) {
              if (this.pickerType == 'select') {
                input.innerText = input.getAttribute('value')
                return
              }
              input.classList.remove('disabled')
            } else {
              if (existingOptionInputsValues.includes(input.getAttribute('value'))) {
                if (this.pickerType == 'select') {
                  input.innerText = this.textStrings.soldOutVariantValueLabel.replace(
                    '[value]',
                    input.getAttribute('value')
                  )
                  return
                }
                input.classList.add('disabled')
              } else {
                if (this.pickerType == 'select') {
                  input.innerText = this.textStrings.unavailableVariantValueLabel.replace(
                    '[value]',
                    input.getAttribute('value')
                  )
                  return
                }
                input.classList.add('disabled')
              }
            }
          })
        },

        zoom(e) {
            const zoomer = this.$el;
            let offsetX;
            let offsetY;

            this.$event.offsetX ? offsetX = this.$event.offsetX : offsetX = this.$event.touches[0].pageX;
            this.$event.offsetY ? offsetY = this.$event.offsetY : offsetX = this.$event.touches[0].pageX;
            const x = offsetX / zoomer.offsetWidth*100;
            const y = offsetY/zoomer.offsetHeight*100;

            zoomer.style.backgroundPosition = x + '% ' + y + '%';
        },
      
        getVariantData() {
          this.variantData =
            this.variantData || JSON.parse(this.el.querySelector(this.selectors.variantsJson).textContent)
            

          this.inventoryData = JSON.parse(this.el.querySelector("[data-prodify-variants-json-new]").textContent);

          this.variantData.forEach(variant => {
            variant.inventory_quantity = this.inventoryData.find(inventory => inventory.id === variant.id).inventory_quantity;
            variant.inventory_policy = this.inventoryData.find(inventory => inventory.id === variant.id).inventory_policy;
          });
          
          return this.variantData
        },

        addToCart(id, qty = 1) {
          // Use the current variant ID instead of the passed parameter
          const variantId = this.currentVariant?.id || id;
          
          // Ensure we have a valid variant
          if (!variantId) {
            console.error('Cannot add to cart: No variant selected');
            return;
          }
          
          if (!this.currentVariant?.available) {
            console.warn('Cannot add to cart: Variant is not available');
            return;
          }
          
          // console.log('addToCart called with:', { 
          //   passedId: id, 
          //   currentVariantId: this.currentVariant?.id,
          //   usingVariantId: variantId,
          //   qty, 
          //   chosenColor: this.chosenColor 
          // });
          
          // Build properties object if color is selected
          const properties = {};
          console.log(this.chosenColor);
          if (this.chosenColor?.name) {
            properties.color = this.chosenColor.name + ' - ' + this.chosenColor.colorBook + ' - ' + this.chosenColor.description;
          }
          
          // console.log('Properties being added:', properties);
          
          // Get product data from the component
          const productData = {
            id: this.el.dataset.id,
            handle: this.el.dataset.handle,
            url: this.el.dataset.url,
            title: this.el.dataset.title,
            image: this.el.dataset.image,
            variant: {
              id: variantId,
              price: this.currentVariant?.price,
              compare_at_price: this.currentVariant?.compare_at_price,
              available: this.currentVariant?.available,
              title: this.currentVariant?.title,
              options: this.currentVariant?.options
            },
            quantity: qty,
            properties: properties
          };

          // console.log('Product data:', productData);

          // Save product to global store (overwrites previous product)
          if (this.$store?.global) {
            // console.log("productData", productData);
            this.$store.global.lastAddedProduct = productData;
          }
          
          const body = {
            items: [
              {
                id: variantId,
                quantity: qty,
                ...(Object.keys(properties).length > 0 && { properties })
              }
            ]  
          }
          
          // console.log('Request body being sent:', JSON.stringify(body, null, 2));
          
          const options = {
            firstCallback: function(requestState) {
              /**
               * This callback function will be called first after the request is performed,
               * thus none of request subscribers knows the result of the request,
               * thus Cart state is not updated yet, sections are not updated yet,
               * everything is not updated yet.
               */
            },
            lastCallback: function(requestState) {
              /**
               * This callback-function will be called the latest
               * among request subscribers,
               * thus all the request subscribers are executed,
               * thus Cart state is updated, sections are updated,
               * everything is updated.
               */
            },
            info: {
              /**
               * Any additional data you want to attach to the Request state object.
               * Don't use the "initiator" and the "cancel" keys.
               */
              // fromProdifyComponent: true,
              productId: this.el.dataset.id
            },
          
            // whether the request should go to the beginning of the queue rather than to the end
            important: false
          }
          
          setTimeout(() => {
            window.liquidAjaxCart.add(body, options);
          }, 100);
        },

        changeCart(id, qty = 1) {
          const body = {
            id: id,
            quantity: Number(qty)
          }

          
          const options = {
            firstCallback: function(requestState) {
              /**
               * This callback function will be called first after the request is performed,
               * thus none of request subscribers knows the result of the request,
               * thus Cart state is not updated yet, sections are not updated yet,
               * everything is not updated yet.
               */
            },
            lastCallback: function(requestState) {
              /**
               * This callback-function will be called the latest
               * among request subscribers,
               * thus all the request subscribers are executed,
               * thus Cart state is updated, sections are updated,
               * everything is updated.
               */
            },
            info: {
              /**
               * Any additional data you want to attach to the Request state object.
               * Don't use the "initiator" and the "cancel" keys.
               */
              // myParameter: 'value'
            },
          
            // whether the request should go to the beginning of the queue rather than to the end
            important: false
          }
          
          setTimeout(() => {
            window.liquidAjaxCart.change(body, options);
          }, 100);
        },

        addColorChoice() {
          // Prevent infinite loop
          if (this.isAddingColorChoice || !this.chosenColor?.id) {
            return;
          }
          
          this.isAddingColorChoice = true;
          
          const body = {
            items: [
              {
                id: this.chosenColor.id,
                quantity: 1
              }
            ]  
          }
          
          const options = {
            firstCallback: function(requestState) {
            },
            lastCallback: function(requestState) {
              // Reset flag after the request completes
              this.isAddingColorChoice = false;
            }.bind(this),
            info: {
              myParameter: 'value'
            },
            important: false
          }
          
          liquidAjaxCart.add(body, options);
        },

        // updateColorChoice() {
        //   const body = {
        //     id: this.color.lineItemId,
        //     properties: {
        //       embossing: this.colorChoice.name
        //     }
        //   }
          
        //   const options = {
        //     firstCallback: function(requestState) {
        //     },
        //     lastCallback: function(requestState) {
        //     },
        //     info: {
        //       myParameter: 'value'
        //     },
        //     important: false
        //   }
        //   liquidAjaxCart.change(body, options);
          
          // this.addColorChoice();
        //   this.$store.global.popup_cart = false;
        // },

        removeColorChoice() {
          // const embossingProduct = this.$store.global.cart.items.find(el => el.product_type === 'Addon');
          // this.embossing.id = embossingProduct.id.toString();
          // const newQuantity = embossingProduct.quantity - 1;

          // const body = {
          //     id: this.embossing.id,
          //     quantity: newQuantity
          // }
          
          // const options = {
          //   firstCallback: function(requestState) {
          //   },
          //   lastCallback: function(requestState) {
          //   },
          //   info: {
          //     myParameter: 'value'
          //   },
          //   important: false
          // }
          
          // liquidAjaxCart.change(body, options);          
        },

        calcLiters() {
            const size = Number(document.querySelector('[data-size]').value);
            const layers = Number(document.querySelector('[data-layers]').value);
            const result = (size * layers) / 10;
            const resultElement = document.querySelector('[data-result]');
            if (result > 0) {
                resultElement.innerHTML = result + ' ' + resultElement.dataset.unit;
            }
        },

        async loadColors() {
            this.colors = [];
            this.isLoadingColors = true;

            try {
              const colorsUrl = 'https://mode-voor-muren.myshopify.com/cdn/shop/t/1/assets/colors.json';
              const response = await axios.get(colorsUrl);
              this.colors = response.data;
              this.colorsLoaded = true;
            } catch (error) {
              console.error('Error loading colors:', error);
              this.colors = [];
              this.colorsLoaded = false;
            } finally {
              this.isLoadingColors = false;
            }
        },

      }
  }
}